import { PermissionEnum } from '@thro-types/access-handler';

import { createContext } from 'react';

import { AuthorRole } from 'types/AppTypes';

interface IAuthContext {
  user: any;
  authorRoles: AuthorRole[];
  permissions: PermissionEnum[];
}

const AuthContext = createContext<IAuthContext>({
  user: null,
  authorRoles: [],
  permissions: []
});

export default AuthContext;
